import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import useApsDiscoveryStore from '@/stores/useApsDiscoveryStore';

export default function ApsDataExtractionDiscoveryBanner() {
    const theme = useTheme();
    const replayVideoModal = useApsDiscoveryStore((state) => state.replayVideoModal);
    const startTryItNow = useApsDiscoveryStore((state) => state.startTryItNow);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                flexWrap: 'wrap',
                p: 2,
                borderRadius: '8px',
                border: `1px solid ${theme.palette.primary.P_100}`,
                backgroundColor: theme.palette.primary.P_50,
            }}
        >
            <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ minWidth: 0 }}>
                <AutoAwesomeIcon sx={{ mt: '2px', color: theme.palette.primary.main }} />
                <Box>
                    <Typography variant="h4">APS data extraction is here</Typography>
                    <Typography variant="body2" sx={{ mt: 0.25 }}>
                        Drag and drop an Agreement of Purchase and Sale into Lexo to extract details
                        and prefill your intake.
                    </Typography>
                </Box>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ flexShrink: 0 }}>
                <Button
                    variant="outlined"
                    onClick={replayVideoModal}
                    sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                >
                    Watch the video
                </Button>
                <Button
                    variant="contained"
                    onClick={startTryItNow}
                    sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                >
                    Try it out now
                </Button>
            </Stack>
        </Box>
    );
}
